<template>
    <div class="float-left">
        <span>
            <i
                @click.stop="abrirModalEditarItem()"
                class="fa fa-edit fa-lg mr-2 icon-button text-primary"
                title="Editar item contrato"
            ></i>
        </span>
        <b-modal id="modalInserirSubItem" v-model="mostrarModalInserirItem">
            <div slot="modal-title">
                Item do Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição Resumida</label>
                        <b-form-textarea
                            v-model="descricaoResumida"
                            :rows="4"
                            :maxlength="200"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é obrigatório"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Quantidade</label>
                        <b-form-input
                            type="number"
                            id="solictGedoc"
                            v-model="quantidade"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalEditarItem()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="atualizarItemContrato()"
                    class="ml-1"
                    >Atualizar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        parentData: Object,
        desativarBotao: Boolean
    },

    data() {
        return {
            itemContrato: {},
            descricao: this.parentData.descricao,
            descricaoResumida: this.parentData.descricaoResumida,
            valor: this.parentData.valorUnitario,
            quantidade: this.parentData.quantidade,
            mostrarModalInserirItem: false,
            operacao: 'EDIÇÃO',
            erros: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    methods: {
        abrirModalEditarItem() {
            if (!this.desativarBotao) {
                this.mostrarModalInserirItem = true
            }
        },

        fecharModalEditarItem() {
            this.mostrarModalInserirItem = false
            //this.resetAtualizarItem()
        },

        resetAtualizarItem() {
            this.descricao = ''
            this.descricaoResumida = ''
            this.valor = 0
            this.quantidade = 0
            this.erros = []
            this.itemContrato = {}
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        atualizarItemContrato() {
            this.itemContrato.itemContratoId = this.parentData.itemContratoId
            this.itemContrato.descricao = this.descricao
            this.itemContrato.descricaoResumida = this.descricaoResumida
            this.itemContrato.valorUnitario = this.valor
            this.itemContrato.quantidade = this.quantidade
            this.itemContrato.status = 1
            this.itemContrato.ordem = this.parentData.ordem
            this.itemContrato.saldoValor = this.valor
            this.itemContrato.saldoQuantidade = this.quantidade
            this.itemContrato.seqRM = this.parentData.seqRM
            this.itemContrato.nuTipoAditivo = 0

            this.$emit('editarItemContrato', this.itemContrato)

            this.fecharModalEditarItem()
        }
    },

    created() {},

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {},

    validations: {
        descricao: {
            required
        },
        valor: {
            required,
            minValue: minValue(0.01)
        }
    }
}
</script>
